"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldContext = void 0;
const react_1 = require("react");
exports.TableFieldContext = react_1.createContext(undefined);
//# sourceMappingURL=table-field-context.js.map